module.exports = __webpack_public_path__ + "static/media/header-img.b77931ee.png";